var _path, _path2, _g, _rect, _path3, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPapaPointsBronze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5702 28.5014L47.5589 50.0764C46.7191 52.66 44.3309 54.3953 41.6162 54.3953H18.9335C16.2188 54.3953 13.8306 52.66 12.9908 50.0764L5.97952 28.5014C5.13973 25.9178 6.05206 23.1111 8.25058 21.5152L26.6032 8.18177C27.7025 7.38383 28.9887 6.98486 30.2748 6.98486C31.561 6.98486 32.85 7.38383 33.9493 8.18177L52.3019 21.5152C54.4976 23.1111 55.4128 25.9178 54.573 28.5014H54.5702Z",
    fill: "url(#paint0_linear_118_2720)",
    stroke: "url(#paint1_linear_118_2720)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6427 18.3373L36.29 5.00392C32.7942 2.46223 28.0958 2.46223 24.5999 5.00392L6.24732 18.3373C2.75144 20.8762 1.30064 25.3458 2.63426 29.4555L9.64554 51.0306C10.9792 55.1402 14.7819 57.9023 19.1036 57.9023H41.7891C46.1109 57.9023 49.9108 55.1402 51.2472 51.0306L58.2585 29.4555C59.5949 25.3458 58.1441 20.879 54.6455 18.3373H54.6427ZM54.7403 28.3116L47.7291 49.8867C46.8893 52.4702 44.501 54.2056 41.7863 54.2056H19.1036C16.389 54.2056 14.0007 52.4702 13.1609 49.8867L6.14967 28.3144C5.30988 25.7308 6.22221 22.9241 8.42073 21.3282L26.7734 7.99202C27.8726 7.19408 29.1588 6.79511 30.445 6.79511C31.7312 6.79511 33.0202 7.19408 34.1194 7.99202L52.4721 21.3254C54.6678 22.9213 55.5829 25.7281 54.7431 28.3116H54.7403Z",
    fill: "url(#paint2_linear_118_2720)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_118_2720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8786 40.0382C22.8172 40.5627 22.9818 41.09 23.3334 41.4862C23.8718 42.0888 24.7591 42.2757 25.4928 41.9409L30.9361 39.4439L36.3794 41.9409C36.6249 42.0525 36.8844 42.1111 37.1522 42.1111C37.6795 42.1111 38.1873 41.8824 38.5389 41.4862C38.8904 41.0928 39.055 40.5655 38.9936 40.041L38.3017 34.0927L42.3584 29.6873C42.8132 29.1962 42.9666 28.4931 42.7601 27.857C42.5537 27.2209 42.018 26.7438 41.3624 26.6099L35.4894 25.4297L32.5543 20.2096C32.2251 19.6265 31.6057 19.2666 30.9389 19.2666C30.2721 19.2666 29.6499 19.6293 29.3235 20.2124L26.3884 25.4297L20.5155 26.6099C19.8598 26.741 19.3241 27.2181 19.1177 27.857C18.9112 28.4931 19.0647 29.1934 19.5166 29.6845L23.5733 34.0899L22.8814 40.0354L22.8786 40.0382Z",
    fill: "url(#paint3_linear_118_2720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8786 40.0382C22.8172 40.5627 22.9818 41.09 23.3334 41.4862C23.8718 42.0888 24.7591 42.2757 25.4928 41.9409L30.9361 39.4439L36.3794 41.9409C36.6249 42.0525 36.8844 42.1111 37.1522 42.1111C37.6795 42.1111 38.1873 41.8824 38.5389 41.4862C38.8904 41.0928 39.055 40.5655 38.9936 40.041L38.3017 34.0927L42.3584 29.6873C42.8132 29.1962 42.9666 28.4931 42.7601 27.857C42.5537 27.2209 42.018 26.7438 41.3624 26.6099L35.4894 25.4297L32.5543 20.2096C32.2251 19.6265 31.6057 19.2666 30.9389 19.2666C30.2721 19.2666 29.6499 19.6293 29.3235 20.2124L26.3884 25.4297L20.5155 26.6099C19.8598 26.741 19.3241 27.2181 19.1177 27.857C18.9112 28.4931 19.0647 29.1934 19.5166 29.6845L23.5733 34.0899L22.8814 40.0354L22.8786 40.0382Z",
    stroke: "url(#paint4_linear_118_2720)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 55.5,
    width: 47,
    height: 19,
    rx: 4.5,
    fill: "url(#paint5_linear_118_2720)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 70C16.596 70 17.646 69.174 17.646 67.144C17.646 65.926 17.198 65.142 16.232 64.75C16.148 64.722 16.106 64.68 16.106 64.61C16.106 64.554 16.134 64.512 16.204 64.47C16.918 64.064 17.282 63.448 17.282 62.426C17.282 60.942 16.372 60.2 14.944 60.2H12.06V69.692C12.06 69.888 12.172 70 12.368 70H15ZM14.244 61.824H14.608C15 61.824 15.224 62.062 15.224 62.944C15.224 63.826 15 64.064 14.608 64.064H14.244V61.824ZM14.244 65.688H14.678C15.154 65.688 15.434 65.926 15.434 66.934C15.434 67.942 15.154 68.18 14.678 68.18H14.244V65.688ZM22.8671 65.282C22.8391 65.142 22.8671 65.058 22.9791 64.974C23.4831 64.596 23.7911 63.98 23.7911 62.874C23.7911 60.914 22.6711 60.2 21.2431 60.2H18.5131V69.692C18.5131 69.888 18.6251 70 18.8211 70H20.7251V66.15C20.7251 66.066 20.7811 66.01 20.8651 66.01C20.9491 66.01 20.9911 66.052 21.0051 66.136L21.6071 69.72C21.6351 69.902 21.7611 70 21.9431 70H23.9591L22.8671 65.282ZM20.7251 64.4V61.964H20.9771C21.4531 61.964 21.6351 62.202 21.6351 63.182C21.6351 64.162 21.4531 64.4 20.9771 64.4H20.7251ZM27.3545 70.14C29.2165 70.14 30.3085 69.104 30.3085 65.1C30.3085 61.32 29.2165 60.06 27.3545 60.06C25.4925 60.06 24.4005 61.32 24.4005 65.1C24.4005 69.104 25.4925 70.14 27.3545 70.14ZM27.3545 68.236C26.9205 68.236 26.6685 67.984 26.6685 65.1C26.6685 62.216 26.9205 61.964 27.3545 61.964C27.7885 61.964 28.0405 62.216 28.0405 65.1C28.0405 67.984 27.7885 68.236 27.3545 68.236ZM33.1326 70V65.226C33.1326 65.058 33.3426 65.016 33.3986 65.198L34.8686 69.734C34.9246 69.902 35.0366 70 35.2186 70H36.8006V60.508C36.8006 60.312 36.6886 60.2 36.4926 60.2H34.8686V64.148C34.8686 64.316 34.6446 64.344 34.6026 64.176L33.5106 60.466C33.4686 60.298 33.3566 60.2 33.1746 60.2H31.2006V69.692C31.2006 69.888 31.3126 70 31.5086 70H33.1326ZM40.6572 68.236C40.2232 68.236 39.9712 67.984 39.9712 65.1C39.9712 62.216 40.2232 61.964 40.6572 61.964C41.0772 61.964 41.2872 62.328 41.2872 64.232H43.0092C43.2052 64.232 43.3172 64.12 43.3172 63.91V63.784C43.3172 61.138 42.2392 60.06 40.6572 60.06C38.7952 60.06 37.7032 61.32 37.7032 65.1C37.7032 69.104 38.7952 70.14 40.6572 70.14C42.2392 70.14 43.3172 69.062 43.3172 66.416V66.29C43.3172 66.08 43.2052 65.968 43.0092 65.968H41.2872C41.2872 67.872 41.0772 68.236 40.6572 68.236ZM48.1656 70C48.3616 70 48.4736 69.888 48.4736 69.692V68.04H46.3736V65.674H48.1376V64.078C48.1376 63.882 48.0256 63.77 47.8296 63.77H46.3736V62.16H48.2916V60.508C48.2916 60.312 48.1796 60.2 47.9836 60.2H44.1616V70H48.1656Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 55.5,
    width: 47,
    height: 19,
    rx: 4.5,
    stroke: "url(#paint6_linear_118_2720)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_118_2720",
    x: 10.0273,
    y: 10.2666,
    width: 45.8232,
    height: 44.8447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_2720",
    x1: 30.2748,
    y1: 54.3953,
    x2: 30.2748,
    y2: 6.98486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9E3E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C0501B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_2720",
    x1: 4.97512,
    y1: 30.6887,
    x2: 55.5774,
    y2: 30.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9E3E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C0501B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_2720",
    x1: 2.14601,
    y1: 30.499,
    x2: 58.7468,
    y2: 30.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1400F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#802608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#913808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9E3E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C0501B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_2720",
    x1: 19.0256,
    y1: 30.6889,
    x2: 42.8494,
    y2: 30.6889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_118_2720",
    x1: 30.9361,
    y1: 42.3901,
    x2: 30.9361,
    y2: 18.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_118_2720",
    x1: 6.5,
    y1: 65,
    x2: 54.5,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_118_2720",
    x1: 6.5,
    y1: 55,
    x2: 53.9138,
    y2: 76.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#913808"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapaPointsBronze);
export default __webpack_public_path__ + "static/media/papa_points_bronze.c4da2229c58cf2e02fe202e37581079d.svg";
export { ForwardRef as ReactComponent };